import { type FC } from 'react'

import { MenuItem } from './MenuItem'
import type { MenuItemProps } from './MenuItem.interface'

export interface MenuIListProps {
  routes: MenuItemProps[]
  collapsed?: boolean
}

export const MenuIList: FC<MenuIListProps> = (props) => {
  const { routes, collapsed } = props

  return (
    <nav>
      <ul className={`sidebar__links ${collapsed ? 'sidebar__links-collapsed' : ''}`}>
        {routes.map((route, index) => (
          <li className="w-full" key={index}>
            <MenuItem icon={route.icon} {...route}>
              {route.children}
            </MenuItem>
          </li>
        ))}
      </ul>
    </nav>
  )
}
